import React,{useEffect,useRef,useState} from 'react';
import {Button,CircularProgress} from '@material-ui/core';
import {v4 as uuid} from 'uuid';
import api from '../../services/api';

const names={pdv:'PDV',vendas:'Venda',titulo:'Título',baixa:'Baixa',titulo_legado:'Título',servico:'Serviço',pedido:'Pedido'};
const states={APROVADO:'Fiscal',NOVO:'Confirmado',registrado:'Registrado',completed:'Concluído',cancelled:'Cancelado',open:'Aberto',in_progress:'Em preparo',ready_for_pickup:'Pronto',out_for_delivery:'Em entrega',pending_payment:'Aguardando pagamento'};
function date(value,report){
 if(!value)return '';
 if(report.source==='delivery')return new Date(value).toLocaleString('pt-BR',{timeZone:report.timezone});
 const [y,m,d]=value.slice(0,10).split('-');return `${d}/${m}/${y} ${value.slice(11,16)}`.trim();
}
export default function ReportDocuments({report,className}){
 const [items,setItems]=useState([]),[cursor,setCursor]=useState(null),[consultedAt,setConsultedAt]=useState(null),[busy,setBusy]=useState(false),[error,setError]=useState(''),alive=useRef(true);
 const load=async(next=null)=>{
  setBusy(true);setError('');
  try{
   const days=(Date.parse(report.period.toExclusive)-Date.parse(report.period.from))/86400000;
   const {data}=await api.post(`/personal-assistant/connections/${report.source}/reports/details`,{
    contractVersion:1,requestId:uuid(),reportId:report.reportId,period:report.period,timezone:report.timezone,dayBasis:'civil',filters:{},
    ...(days>31?{background:true}:{}),...(next?{cursor:next}:{})
   },{timeout:10000});
   if(!alive.current)return;
   setConsultedAt(data.consultedAt||null);
   setItems(previous=>[...new Map((next?[...previous,...data.items]:data.items).map(row=>[row.id,row])).values()]);setCursor(data.nextCursor);
  }catch(e){if(alive.current)setError('Não foi possível conferir os documentos agora.');}
  finally{if(alive.current)setBusy(false);}
 };
 // The parent keys this component by report so responses cannot cross private reports.
 // eslint-disable-next-line react-hooks/exhaustive-deps
 useEffect(()=>{alive.current=true;load();return()=>{alive.current=false;};},[]);
 return <section aria-label="Documentos consultados agora"><h3>Documentos consultados agora</h3>
  <p>Esta lista é uma nova consulta e pode diferir do resumo histórico acima. Os documentos podem mudar entre páginas.</p>
  {consultedAt&&<small>Última página consultada em {new Date(consultedAt).toLocaleString('pt-BR',{timeZone:report.timezone})}.</small>}
  {items.length>0&&<table className={className}><thead><tr><th>Documento e data</th><th>Valor</th></tr></thead><tbody>{items.map(row=><tr key={row.id}><td><b>{names[row.origin]||'Documento'} #{row.documentId}</b><br/><small>{date(row.occurredAt,report)} · {states[row.status]||'Confirmado'}</small></td><td>{row.amountCents==null?'Indisponível':(row.amountCents/100).toLocaleString('pt-BR',{style:'currency',currency:'BRL'})}</td></tr>)}</tbody></table>}
  {!busy&&!error&&!items.length&&<p>Nenhum documento nesse período.</p>}
  {error&&<p role="alert">{error} <Button onClick={()=>load(cursor)} disabled={busy}>Tentar novamente</Button></p>}
  {busy&&<CircularProgress size={20} aria-label="Conferindo documentos"/>}
  {cursor&&!error&&<Button disabled={busy} onClick={()=>load(cursor)}>Carregar mais documentos</Button>}
 </section>;
}
